<template>
  <div
    class="only-lyric height-all"
    @click.stope="onClickOutside"
    :class="{
      'lyric-edit-mode': renderData.editMode,
      'lyric-edit-mode-mobile': createRenderType == 'mobile',
    }"
  >
    <div class="lyric-edit">
      <LyricEdit
        ref="refLyricEdit"
        :lyric="renderData.lyric"
        :isLoading="renderData.isLoading"
        @countChange="onCountChange"
        @input="onInput"
        @change="onChange"
        @blur="onBlur"
        @focus="onFocus"
      ></LyricEdit>
    </div>

    <div class="lyric-footer flex">
      <div
        class="flex1 count"
        :class="{ 'count-error': renderData.charCount >= MAX_LYRIC_COUNT }"
      >
        {{ renderData.charCount }}/{{ MAX_LYRIC_COUNT }}
      </div>
      <div class="lyric-footer-btns">
        <div class="fn-inline lyric-footer-btn btn1">
          <Bubble
            :content="$$t('create.song_structure')"
            placement="top"
            :disabled="renderData.tagVisible"
          >
            <Button
              :renderStyle="{
                '--padding': '0',
                '--width':
                  $$language() == 'cn'
                    ? '60px'
                    : createRenderType != 'mobile'
                    ? '40px'
                    : '56px',
                '--height': '100%',
                '--borderRadius': '50px',
                '--background': 'rgba(255, 255, 255, 0.1)',
                '--fontColor': '#fff',
                '--fontSize': '12px',
                '--fontWeight': 'normal',
                '--border': 'none',
                '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
                '--fontColorHover': '#fff',
              }"
              :disabled="
                renderData.isLoading ||
                renderData.charCount > MAX_LYRIC_COUNT - 10
              "
              @click.stop="toggleTagVisible"
            >
              <i
                class="block"
                v-if="$$language() != 'cn' && createRenderType != 'mobile'"
              ></i>
              <span class="block" v-else>{{
                $$t("create.song_structure_btn")
              }}</span>
            </Button>
          </Bubble>
          <div class="lyric-tag-items" v-if="renderData.tagVisible">
            <template v-for="(item, index) in getSegTypes()" :key="index">
              <div
                class="lyric-tag-item tc pointer"
                @click.stop="
                  () => {
                    doAddTag(item)
                  }
                "
              >
                {{ item[`label_${$$language()}`] }}
              </div>
            </template>
          </div>
        </div>
        <div
          class="fn-inline lyric-footer-btn btn2"
          v-if="createRenderType != 'mobile'"
        >
          <Bubble :content="$$t('create.ai_generate_row')" placement="top">
            <Button
              :renderStyle="{
                '--padding': '0',
                '--width':
                  $$language() == 'cn'
                    ? '62px'
                    : createRenderType != 'mobile'
                    ? '40px'
                    : '36px',
                '--height': '100%',
                '--borderRadius': '50px',
                '--background': 'rgba(255, 255, 255, 0.1)',
                '--fontColor': '#fff',
                '--fontSize': '12px',
                '--fontWeight': 'normal',
                '--border': 'none',
                '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
                '--fontColorHover': '#fff',
              }"
              :loading="
                renderData.curGenerateType === 'row' && renderData.isLoading
              "
              :disabled="
                renderData.isLoading ||
                renderData.charCount > MAX_LYRIC_COUNT - 10
              "
              @click="onContinueWritingClick"
            >
              <i
                class="block"
                v-if="$$language() != 'cn' && createRenderType != 'mobile'"
              ></i>
              <span class="block" v-else>{{
                $$t("create.ai_generate_row_btn")
              }}</span>
              <!-- Continue writing -->
            </Button>
          </Bubble>
        </div>
        <div class="fn-inline lyric-footer-btn btn3">
          <Bubble
            :content="
              renderData.lyric
                ? $$t('create.ai_generate_lyrics')
                : $$t('create.ai_generate_random_lyrics')
            "
            placement="top"
            :disabled="createRenderType == 'mobile'"
          >
            <Button
              :renderStyle="{
                '--padding': '0',
                '--width':
                  $$language() == 'cn'
                    ? '62px'
                    : createRenderType != 'mobile'
                    ? '40px'
                    : renderData.lyric
                    ? '112px'
                    : '146px',
                '--height': '100%',
                '--borderRadius': '50px',
                '--background': 'rgba(255, 255, 255, 0.1)',
                '--fontColor': '#fff',
                '--fontSize': '12px',
                '--fontWeight': 'normal',
                '--border': 'none',
                '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
                '--fontColorHover': '#fff',
              }"
              :loading="
                renderData.curGenerateType === 'all' && renderData.isLoading
              "
              :disabled="
                renderData.isLoading ||
                renderData.charCount > MAX_LYRIC_COUNT - 500
              "
              @click="onWriteAllLyricClick"
            >
              <i
                class="block"
                v-if="$$language() != 'cn' && createRenderType != 'mobile'"
              ></i>
              <span v-else class="block">{{
                renderData.lyric
                  ? $$t("create.ai_generate_lyrics")
                  : $$t("create.ai_generate_random_lyrics")
              }}</span>
              <!-- Write a lyric -->
            </Button>
          </Bubble>
        </div>
      </div>
    </div>

    <div class="lyric-box-mask" v-if="renderData.isLoading"></div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue"
import Bubble from "@/components/bubble/bubble.vue"
import LyricEdit from "../editLyric/inputLyric.vue"
import Button from "@/components/basic/button/Button.vue"
import { getSegTypes } from "@/config/const.js"
import feedListApi from "@/api/api/feedListApi.js"
import message from "@/components/functionCallComponent/message.jsx"
import globalConfig from "@/config/config.js"
const MAX_LYRIC_COUNT = globalConfig.MAX_LYRIC_COUNT
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)
import useUserDataStore from "@/store/userDataStore.js"
const globalProperties = (
  getCurrentInstance() || window?.$getVueCurrentInstance?.()
).appContext?.config?.globalProperties
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const lyricDataStore = {}

const userDataStore = useUserDataStore()

const props = defineProps({
  pitem: {
    type: Object,
    default: null,
  },
  item: {
    type: Object,
    default: null,
  },
})

const emits = defineEmits(["change"])
const refLyricEdit = ref(null)
const renderData = reactive({
  lyric: "",
  charCount: 0,
  isLoading: false,
  tagVisible: false,
  curGenerateType: "",
  editMode: false,
})

const onInput = async (value) => {
  if (!(await userDataStore.checkLoginStatus())) {
    return
  }
  renderData.lyric = value
}

const onChange = (value) => {
  renderData.lyric = value
}

const onBlur = (count) => {
  renderData.editMode = false
}

const onFocus = (count) => {
  renderData.editMode = true
}

const onCountChange = (count) => {
  renderData.charCount = count
}

const toggleTagVisible = async () => {
  if (!(await userDataStore.checkLoginStatus())) {
    return
  }
  renderData.tagVisible = !renderData.tagVisible
}

const doAddTag = (tag) => {
  refLyricEdit.value.insertTag(tag)
  renderData.tagVisible = false
  globalProperties?.logClickEvent("create_structure", {
    add_tag_type: tag,
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  })
}

const onClickOutside = async () => {
  renderData.tagVisible = false
}

const onContinueWritingClick = async () => {
  renderData.tagVisible = false
  globalProperties?.logClickEvent("create_ailyrics", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  })

  if (!(await userDataStore.checkLoginStatus())) {
    return
  }

  if (renderData.isLoading) {
    return
  }
  renderData.isLoading = true
  const params = {
    lyrics: refLyricEdit.value?.getBeforeLyrics() ?? "",
    create_title: false,
    type: 1,
    song_id: props.item?.song_id,
  }
  renderData.curGenerateType = "row"
  feedListApi
    .generateLyrics(params)
    .then((res) => {
      renderData.isLoading = false
      const { code, data, msg } = res
      if (code == 200) {
        refLyricEdit.value?.insertLyric(data.lyrics)
      } else {
        message.error({
          position: "top",
          content: $$t("create.ai_generate_lyric_failed"),
        })
      }
    })
    .catch((e) => {
      renderData.isLoading = false
      message.error({
        position: "top",
        content: $$t("create.ai_generate_lyric_failed"),
      })
    })
}
const onWriteAllLyricClick = async () => {
  renderData.tagVisible = false
  globalProperties?.logClickEvent("create_ailyricsall", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
  })
  if (!(await userDataStore.checkLoginStatus())) {
    return
  }

  if (renderData.isLoading) {
    return
  }
  renderData.isLoading = true
  const params = {
    lyrics: refLyricEdit.value?.getBeforeLyrics() ?? "",
    create_title: false,
    type: 4,
    song_id: props.item?.song_id,
  }
  renderData.curGenerateType = "all"
  await feedListApi
    .generateLyrics(params)
    .then((res) => {
      renderData.isLoading = false
      const { code, data, msg } = res
      if (code == 200) {
        refLyricEdit.value?.insertLyric(data.lyrics)
      } else {
        message.error({
          position: "top",
          content: $$t("create.ai_generate_lyric_failed"),
        })
      }
    })
    .catch((e) => {
      renderData.isLoading = false
      message.error({
        position: "top",
        content: $$t("create.ai_generate_lyric_failed"),
      })
    })
}

defineExpose({
  getLyrics() {
    return renderData.lyric
  },
})

watch(
  () => renderData.lyric,
  (newVal) => {
    emits("change", renderData.lyric, renderData.charCount)
  }
)
onMounted(() => {
  document?.addEventListener("click", onClickOutside)
})
onUnmounted(() => {
  document?.removeEventListener("click", onClickOutside)
})
</script>
<style lang="scss" scope>
.only-lyric {
  padding: 16px 16px 16px 16px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0);
  position: relative;
  .lyric-box-mask {
    position: absolute;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.125);
  }
  &.lyric-edit-mode {
    border: 1px solid #94adff;
    background-color: rgba(148, 173, 255, 0.1);
  }
  .lyric-edit {
    height: calc(100% - 30px - 16px);
  }
  .lyric-footer {
    padding: 16px 0 0 0;
    align-items: end;
    .count {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 0.5);
      vertical-align: bottom;
      width: calc(100% - 40px * 3 - 8px * 3);
    }
    .count-error {
      color: #ff4d4f;
    }
    .lyric-footer-btn {
      margin-left: 8px;
      height: 32px;
      .custom-button .el-button {
        padding: 0 8px;
      }
      i {
        height: 16px;
        width: 16px;
        background-color: rgba(255, 255, 255, 0.5);
      }
      .el-button.is-loading {
        span {
          display: none;
        }
        i.is-loading {
          display: block;
          height: 16px;
          width: 16px;
          background: url(@/assets/img/loading-mini-3x.png) !important;
          background-size: 100% 100% !important;
          animation: animation-rotate-infinite 0.75s infinite normal linear;
          svg {
            display: none;
          }
        }
      }
    }
    .btn1 {
      position: relative;
      i {
        background: url(@/assets/img/lyric-tag-ico.png);
        background-size: cover;
      }
    }
    .btn2 {
      i {
        background: url(@/assets/img/lyric-row-ico.png);
        background-size: cover;
      }
    }
    .btn3 {
      i {
        background: url(@/assets/img/lyric-whole-ico.png);
        background-size: cover;
      }
    }

    .lyric-tag-items {
      background: rgba(255, 255, 255, 0.2);
      border: 1px solid rgba(255, 255, 255, 0);
      backdrop-filter: blur(20px);
      width: 128px;
      border-radius: 8px;
      position: absolute;
      bottom: 40px;
      left: -40px;
      .lyric-tag-item {
        line-height: 42px;
        font-family: HarmonyOS Sans SC;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0em;
        color: #fff;
        &:first-child {
          border-radius: 8px 8px 0 0;
        }
        &:last-child {
          border-bottom: none;
          border-radius: 0 0 8px 8px;
        }
        &:hover {
          background: rgba(255, 255, 255, 0.1);
        }
      }
    }
  }
  &.lyric-edit-mode-mobile {
    .lyric-tag-items {
      .lyric-tag-item {
        line-height: 32px;
      }
    }
  }
}
</style>
